module.exports = __webpack_public_path__ + "static/media/5import-6.660fd519.xlsx";